import { getPostureCheckUserEmail, joinMultiValue, normalizePostureCheckRoles } from './postureCheckRowUtils'
import { sortPostureCheckExportRows } from './postureCheckExportSort'
import { getEmployeeFullName } from './table.util'

const formatSharedMailboxSignInStatus = (row, intl) => {
  if (row.formattedSigninEnabled) {
    return row.formattedSigninEnabled
  }

  return row.isUserSigninEnabled
    ? intl.formatMessage({ id: 'SECURE.POSTURE.ALERTS.SHARED_MAILBOX_NOT_BLOCKED' })
    : intl.formatMessage({ id: 'SECURE.POSTURE.ALERTS.SHARED_MAILBOX_BLOCKED' })
}

export const formatBlockLegacyAuthenticationReportData = (data, sort, intl) =>
  sortPostureCheckExportRows(data, sort).map((row) => ({
    employee: getEmployeeFullName(row),
    email: getPostureCheckUserEmail(row),
    license: joinMultiValue(row.licenseType),
    role: joinMultiValue(normalizePostureCheckRoles(row)),
    group: joinMultiValue(row.group),
    legacyAuthenticationStatus: row.blockLegacyAuthenticationAccess
      ? intl.formatMessage({ id: 'GENERAL.BLOCKED' })
      : intl.formatMessage({ id: 'SECURE.POSTURE.ALERTS.LEGACY_AUTH_NOT_BLOCKED' }),
  }))

export const formatBlockSignInSharedMailboxesReportData = (data, sort, intl) =>
  sortPostureCheckExportRows(data, sort).map((row) => ({
    mailboxName: row.formattedName ?? getEmployeeFullName(row),
    email: getPostureCheckUserEmail(row),
    signInStatus: formatSharedMailboxSignInStatus(row, intl),
  }))

export const formatInactiveAccountsReportData = (data, sort, intl) =>
  sortPostureCheckExportRows(data, sort).map((row) => {
    const noneLabel = intl.formatMessage({ id: 'GENERAL.NONE' })
    const blockedLabel = intl.formatMessage({ id: 'GENERAL.BLOCKED' })

    let lastSignIn = ''
    if (!row.isUserSigninEnabled) {
      lastSignIn = blockedLabel
    } else if (row.lastActive != null) {
      lastSignIn = String(row.lastActive)
    }

    let lastAppActivityDate = ''
    let lastAppActivityApp = ''
    if (!row.lastAppActivity) {
      lastAppActivityDate = noneLabel
    } else {
      lastAppActivityDate = row.lastAppActivity.activityDate ?? ''
      lastAppActivityApp = row.lastAppActivity.appName ?? ''
    }

    return {
      employee: getEmployeeFullName(row),
      email: getPostureCheckUserEmail(row),
      license: joinMultiValue(row.licenseType),
      role: joinMultiValue(normalizePostureCheckRoles(row)),
      group: joinMultiValue(row.group),
      lastSignIn,
      lastAppActivityDate,
      lastAppActivityApp,
    }
  })

export const formatPowershellAccessForNonAdminsReportData = (data, sort, intl) =>
  sortPostureCheckExportRows(data, sort).map((row) => ({
    name: getEmployeeFullName(row),
    email: getPostureCheckUserEmail(row),
    powershellAccess: row.remotePowerShellEnabled
      ? intl.formatMessage({ id: 'GENERAL.YES' })
      : intl.formatMessage({ id: 'GENERAL.NO' }),
  }))

export const formatSelfServePasswordResetReportData = (data, sort) =>
  sortPostureCheckExportRows(data, sort).map((row) => ({
    employee: getEmployeeFullName(row),
    email: getPostureCheckUserEmail(row),
    license: joinMultiValue(row.licenseType),
    role: joinMultiValue(normalizePostureCheckRoles(row)),
    group: joinMultiValue(row.group),
    ssprStatus: row.selfServicePasswordReset ?? '',
  }))
